import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../common/components/DeleteModal";
import {
  CREATEPDF,
  DOWNLOADXLS,
  DOWNLOADXMLCONFIG,
  DOWNLOADXMLINIES,
} from "../../fdes/constants/metadata";
// import EDECLogo from "../../../icons/Pictogramme_EDEC_vert.svg";
import { Copy } from "../../../assets/icons/Copy";
import { FileCheck } from "../../../assets/icons/FileCheck";
import { Download } from "../../../assets/icons/Download";
import { ThreeDots } from "../../../assets/icons/ThreeDots";
import { Trash } from "../../../assets/icons/Trash";
import { ModalDownloadFiles } from "./modals/ModalDownloadFiles";
import { ModalGenerateFiles } from "./modals/ModalGenerateFiles";
import { AddFolder } from "../../../assets/icons/AddFolder";
import { ModalManageFolder } from "../../folders/components/modals/ModalManageFolder";
import ModalAssignCalculToFolders from "../../folders/containers/ModalAssignCalculToFolders";
import { Box } from "../../../assets/icons/Box";
import { ModalArchiveCalcul } from "./modals/ModalArchiveCalcul";
import { Pen } from "../../../assets/icons/Pen";
import { ModalRenameCalcul } from "./modals/ModalRenameCalcul";
import { CalculTableRows } from "./utils/CalculTableRows";
import { MFCheckbox } from "../../../common/components/MFCheckbox";
import { FINISHED } from "../constants";
import CustomTooltip from "../../../common/components/CustomTooltip";
import { toast } from "react-toastify";

const CalculRow = ({
  calcul,
  isGeneratingReports,
  generatingReportsIds,
  generateReports,
  deleteCalcul,
  duplicateCalcul,
  folders,
  createFolder,
  setCalculArchived,
  updateCalculAttributes,
  calculsColumns,
  selectedCalculs,
  setSelectedCalculs,
}) => {
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [downloadXmlConfig, setDownloadXmlConfig] = useState({});
  const [downloadXmlIniesConfig, setDownloadXmlIniesConfig] = useState({});
  const [downloadXlsConfig, setDownloadXlsConfig] = useState({});
  const [isDownloadFilesModalOpen, setIsDownloadFilesModalOpen] =
    useState(false);
  const [isCreateFilesModalOpen, setIsCreateFilesModalOpen] = useState(false);
  const [dontShowCreateFilesModal, setDontShowCreateFilesModal] =
    useState(false);
  const [dontShowArchiveCalculModal, setDontShowArchiveCalculModal] =
    useState(false);
  const [isManageFolderModalOpen, setIsManageFolderModalOpen] = useState(false);
  const [isAssignCalculModalOpen, setIsAssignCalculModalOpen] = useState(false);
  const [isArchiveCalculModalOpen, setIsArchiveCalculModalOpen] =
    useState(false);
  const [isRenameCalculModalOpen, setIsRenameCalculModalOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [createPdf, setCreatePdf] = useState({});
  const navigate = useNavigate();
  const isCreateExportsClosed = localStorage.getItem("isCreateExportsClosed");
  const isArchiveCalculClosed = localStorage.getItem("isArchiveCalculClosed");

  useEffect(() => {
    if (calcul && calcul.fdesMetadata) {
      setCreatePdf(calcul.fdesMetadata.find((e) => e.paramId === CREATEPDF));
      setDownloadXmlConfig(
        calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLCONFIG),
      );
      setDownloadXmlIniesConfig(
        calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXMLINIES),
      );
      setDownloadXlsConfig(
        calcul.fdesMetadata.find((e) => e.paramId === DOWNLOADXLS),
      );
    }
  }, [calcul]);

  const isLastModel =
    calcul &&
    calcul.model &&
    calcul.lastModel &&
    calcul.lastModel._id === calcul.model._id;

  function createFiles() {
    if (isLastModel || !filesCreatedAfterSave()) {
      generateReports(
        {
          xml: displayDownloadXmlConfig(),
          xmlInies: displayDownloadXmlIniesConfig(),
          xls: displayDownloadXlsConfig(),
        },
        calcul._id,
      );
    } else if (!isLastModel) {
      toast.error(
        "Impossible de générer les fichiers car le modèle utilisé pour ce calcul n'est plus à jour.",
      );
    }
    if (!isCreateExportsClosed && dontShowCreateFilesModal) {
      localStorage.setItem("isCreateExportsClosed", true);
    }
    setIsCreateFilesModalOpen(false);
  }

  function handleCreateFilesClick() {
    if (!isCreateExportsClosed) {
      setIsCreateFilesModalOpen(true);
    } else {
      createFiles();
    }
  }

  function archiveCalcul() {
    setCalculArchived(calcul._id);
    if (!isArchiveCalculClosed && dontShowArchiveCalculModal) {
      localStorage.setItem("isArchiveCalculClosed", true);
    }
    setIsArchiveCalculModalOpen(false);
  }

  function handleArchiveCalculClick() {
    if (!isArchiveCalculClosed) {
      setIsArchiveCalculModalOpen(true);
    } else {
      archiveCalcul();
    }
  }

  async function onSubmitDuplicateCalcul() {
    duplicateCalcul(calcul._id);
  }

  function displayDownloadXmlConfig() {
    if (downloadXmlConfig) return downloadXmlConfig.visible;
    else return true;
  }

  function displayDownloadXmlIniesConfig() {
    if (downloadXmlIniesConfig) return downloadXmlIniesConfig.visible;
    else return false;
  }

  function displayDownloadXlsConfig() {
    if (downloadXlsConfig) return downloadXlsConfig.visible;
    else return false;
  }

  function filesCreatedAfterSave() {
    if (calcul.status === FINISHED) return true;
    if (calcul.reports?.createdAt) {
      return new Date(calcul.reports.createdAt) > new Date(calcul.updatedAt);
    } else return false;
  }

  function openCalcul() {
    navigate(`/fdes/${calcul.productFamily.id}/${calcul._id}`);
  }

  function handleAddFileToFolder() {
    if (folders?.length > 0) {
      setIsAssignCalculModalOpen(true);
    } else {
      setIsManageFolderModalOpen(true);
    }
  }

  function handleChangeSelectedCalculs() {
    if (selectedCalculs.map((c) => c.id).includes(calcul._id)) {
      setSelectedCalculs(selectedCalculs.filter((c) => c.id !== calcul._id));
    } else {
      setSelectedCalculs([
        ...selectedCalculs,
        {
          id: calcul._id,
          name: calcul.title,
          isDuplicable: !!calcul.isCompatible,
          isFinished: calcul.status === FINISHED,
          isRestorable: false,
          simulationMode: calcul?.options?.simulationMode === true,
          folderIds: calcul.folders?.map((f) => f._id) || [],
          outputs: [
            "pdf",
            ...(displayDownloadXmlConfig() ? ["xml"] : []),
            ...(displayDownloadXmlIniesConfig() ? ["inies"] : []),
            ...(displayDownloadXlsConfig() ? ["xls"] : []),
          ],
        },
      ]);
    }
  }

  return (
    <>
      <tr
        className="calcul-raw align-items-center"
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <td className="selection-column">
          {(selectedCalculs.length > 0 || isHovering) && (
            <div className="d-flex align-items-center justify-content-end">
              <MFCheckbox
                checked={selectedCalculs
                  .map((calcul) => calcul.id)
                  .includes(calcul._id)}
                onChange={handleChangeSelectedCalculs}
              />
            </div>
          )}
        </td>
        <CalculTableRows
          calculsColumns={calculsColumns}
          calcul={calcul}
          openCalcul={openCalcul}
          isFinished={calcul.status === FINISHED}
        />

        {/* ACTIONS COLUMN */}

        {selectedCalculs.length === 0 && (
          <td className="actions-column dropdown-column">
            <div className="p-0 flex-center">
              {/* Duplication */}
              <button
                className="action-button"
                onClick={onSubmitDuplicateCalcul}
                data-tooltip-id={`duplication-btn${calcul._id}`}
                data-tooltip-content={"Dupliquer"}
                disabled={!calcul.isCompatible}
              >
                <Copy
                  className={`${calcul.isCompatible ? "text-interaction" : "text-primary-black-disabled"}`}
                />
              </button>
              {calcul?.isCompatible && (
                <CustomTooltip
                  id={`duplication-btn${calcul._id}`}
                  place="top"
                />
              )}
              {/* Files management */}
              {filesCreatedAfterSave() ? (
                <>
                  <button
                    className="action-button"
                    onClick={() => setIsDownloadFilesModalOpen(true)}
                    data-tooltip-id={`download-files-btn${calcul._id}`}
                    data-tooltip-content={"Télécharger"}
                  >
                    <Download className="text-interaction" />
                  </button>
                  <CustomTooltip
                    id={`download-files-btn${calcul._id}`}
                    place="top"
                  />
                </>
              ) : (
                <>
                  {isGeneratingReports &&
                  generatingReportsIds.includes(calcul._id) ? (
                    <div
                      style={{ width: 40, height: 40 }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <div className="spinner-border" role="status" />
                    </div>
                  ) : (
                    <>
                      <button
                        className="action-button"
                        onClick={handleCreateFilesClick}
                        data-tooltip-id={`create-files-btn${calcul._id}`}
                        data-tooltip-content={"Générer"}
                      >
                        <FileCheck className="text-interaction" />
                      </button>
                      <CustomTooltip
                        id={`create-files-btn${calcul._id}`}
                        place="top"
                      />
                    </>
                  )}
                </>
              )}
              {/* Actions dropdown */}
              <div className="dropdown">
                <button
                  className="action-button"
                  type="button"
                  data-toggle="dropdown"
                  data-tooltip-id={`actions-btn${calcul._id}`}
                  data-tooltip-content={"Autres actions"}
                >
                  <ThreeDots className="text-interaction" />
                </button>
                <CustomTooltip id={`actions-btn${calcul._id}`} place="top" />
                <div className="dropdown-menu dropdown-menu-right">
                  <li>
                    <button
                      onClick={() => setIsRenameCalculModalOpen(true)}
                      className="dropdown-item text-primary-black d-flex align-items-center"
                    >
                      <Pen size={22} />
                      <span style={{ marginLeft: 12 }}>Renommer le calcul</span>
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={handleAddFileToFolder}
                      className="dropdown-item text-primary-black d-flex align-items-center"
                    >
                      <AddFolder size={22} />
                      <span style={{ marginLeft: 12 }}>
                        Ajouter à un dossier
                      </span>
                    </button>
                  </li>
                  {calcul.status !== FINISHED && (
                    <li>
                      <button
                        onClick={() => setDeleteModalIsOpen(true)}
                        className="dropdown-item text-primary-black d-flex align-items-center"
                      >
                        <Trash size={22} />
                        <span style={{ marginLeft: 12 }}>Supprimer</span>
                      </button>
                    </li>
                  )}
                  {calcul.status === FINISHED && (
                    <li>
                      <button
                        onClick={handleArchiveCalculClick}
                        className="dropdown-item text-primary-black d-flex align-items-center"
                      >
                        <Box size={22} />
                        <span style={{ marginLeft: 12 }}>Archiver</span>
                      </button>
                    </li>
                  )}
                </div>
              </div>
            </div>
          </td>
        )}
      </tr>
      <DeleteModal
        isOpen={deleteModalIsOpen}
        onClose={setDeleteModalIsOpen}
        onSubmit={() => deleteCalcul(calcul._id)}
      />
      <ModalManageFolder
        isOpen={isManageFolderModalOpen}
        onClose={() => setIsManageFolderModalOpen(false)}
        createFolder={createFolder}
        onCreate={() => setIsAssignCalculModalOpen(true)}
      />
      <ModalAssignCalculToFolders
        isOpen={isAssignCalculModalOpen}
        onClose={() => setIsAssignCalculModalOpen(false)}
        calculIds={[calcul._id]}
        calculFolders={calcul.folders?.map((f) => f._id) || []}
      />
      <ModalGenerateFiles
        isOpen={isCreateFilesModalOpen}
        onClose={() => setIsCreateFilesModalOpen(false)}
        dontShowCreateFilesModal={dontShowCreateFilesModal}
        setDontShowCreateFilesModal={setDontShowCreateFilesModal}
        createFiles={createFiles}
        label={createPdf?.name}
        simulationMode={calcul?.options?.simulationMode === true}
      />
      <ModalDownloadFiles
        isOpen={isDownloadFilesModalOpen}
        onClose={() => setIsDownloadFilesModalOpen(false)}
        displayXmlInies={displayDownloadXmlIniesConfig()}
        displayXml={displayDownloadXmlConfig()}
        displayXls={displayDownloadXlsConfig()}
        calcul={calcul}
        filesCreatedAfterSave={filesCreatedAfterSave}
      />
      <ModalArchiveCalcul
        isOpen={isArchiveCalculModalOpen}
        onClose={() => setIsArchiveCalculModalOpen(false)}
        dontShowCalculArchiveModal={dontShowArchiveCalculModal}
        setDontShowCalculArchiveModal={setDontShowArchiveCalculModal}
        archiveCalcul={archiveCalcul}
      />
      <ModalRenameCalcul
        isOpen={isRenameCalculModalOpen}
        onClose={() => setIsRenameCalculModalOpen(false)}
        calcul={calcul}
        updateCalculAttributes={updateCalculAttributes}
        isFinished={calcul.status === FINISHED}
      />
    </>
  );
};

export default CalculRow;
